'use strict';

var _ = require('lodash');
var StepSposPanelController = function StepSposPanelController($scope) {
  var MAX_ROWS_VISIBLE = 4;
  $scope.showAdd = true;
  var textInputCellRenderer = function textInputCellRenderer(params) {
    switch (params.colDef.field) {
      case 'country':
      case 'priority':
        return '<input type="text" maxlength="2" class="rm-ag-grid-input ' + params.colDef.field + '-input" ' + 'ng-model="entity.significantPos[' + params.rowIndex + '].' + params.colDef.field + '"' + 'ng-blur="onCellEdit(' + params.rowIndex + ', \'' + params.colDef.field + '\')"/>';
      case 'city':
        return '<input type="text" maxlength="5" class="rm-ag-grid-input ' + params.colDef.field + '-input" ' + 'ng-model="entity.significantPos[' + params.rowIndex + '].' + params.colDef.field + '"' + 'ng-blur="onCellEdit(' + params.rowIndex + ', \'' + params.colDef.field + '\')"/>';
      case 'iataFrom':
      case 'iataTo':
        return '<input type="number" maxlength="8" class="rm-ag-grid-input ' + params.colDef.field + '-input" ' + 'ng-model="entity.significantPos[' + params.rowIndex + '].' + params.colDef.field + '"' + 'ng-blur="onCellEdit(' + params.rowIndex + ', \'' + params.colDef.field + '\')"/>';
      default:
        return '<input type="text" maxlength="10" class="rm-ag-grid-input ' + params.colDef.field + '-input" ' + 'ng-model="entity.significantPos[' + params.rowIndex + '].' + params.colDef.field + '"' + 'ng-blur="onCellEdit(' + params.rowIndex + ', \'' + params.colDef.field + '\')"/>';
    }
  };
  var columnDefs = [{
    headerName: '',
    width: 30,
    checkboxSelection: true
  }, {
    headerName: 'Country',
    field: 'country',
    cellRenderer: textInputCellRenderer,
    width: 80
  }, {
    headerName: 'City',
    field: 'city',
    cellRenderer: textInputCellRenderer,
    width: 60
  }, {
    headerName: 'IATA(from)',
    field: 'iataFrom',
    cellRenderer: textInputCellRenderer,
    width: 90
  }, {
    headerName: 'IATA(to)',
    field: 'iataTo',
    cellRenderer: textInputCellRenderer,
    width: 80
  }, {
    headerName: 'Priority',
    field: 'priority',
    cellRenderer: textInputCellRenderer,
    width: 60
  }, {
    headerName: 'POS',
    field: 'spos',
    cellRenderer: textInputCellRenderer,
    width: 60
  }];
  var gridBaseWidth = _.reduce(columnDefs, function (sum, item) {
    return sum + item.width;
  }, 0);
  $scope.onCellEdit = function (rowId, field) {
    var rowData = $scope.gridOptions.rowData[rowId];
    if (field === 'priority') {
      var newIndex = parseInt(rowData.priority, 10) - 1;
      $scope.entity.movePos(rowId, newIndex);
      $scope.gridOptions.api.onNewRows();
    }
  };
  function onRowSelected() {
    $scope.showAdd = $scope.gridOptions.selectedRows.length <= 1;
    $scope.toggleDeleteButton();
  }
  $scope.addNewRow = function () {
    var isRowSelected = !!$scope.gridOptions.selectedRows.length;
    var prevRow = _.last(isRowSelected ? $scope.gridOptions.selectedRows : $scope.gridOptions.rowData);
    $scope.entity.addPos({
      priority: prevRow.priority + 1
    }, prevRow);
    $scope.gridOptions.api.onNewRows();
    $scope.toggleDeleteButton();
    $scope.resizeGrid();
  };
  $scope.removeRow = function () {
    if ($scope.gridOptions.selectedRows.length < 1 || $scope.gridOptions.selectedRows.length === $scope.gridOptions.rowData.length) {
      return;
    }
    $scope.gridOptions.selectedRows.forEach(function (row) {
      $scope.entity.removePos(row);
    });
    $scope.gridOptions.api.onNewRows();
    $scope.toggleDeleteButton();
    $scope.resizeGrid();
  };
  $scope.isScrolled = function () {
    var options = $scope.gridOptions;
    return options.rowData.length > MAX_ROWS_VISIBLE;
  };
  $scope.resizeGrid = function () {
    var options = $scope.gridOptions;
    var noOfRows;
    var scrollWidth;
    var horizontalPadding = 2;
    if ($scope.isScrolled()) {
      noOfRows = MAX_ROWS_VISIBLE;
      scrollWidth = 23;
    } else {
      noOfRows = options.rowData.length;
      scrollWidth = 0;
    }
    $scope.height = noOfRows * options.rowHeight + options.headerHeight;
    $scope.width = gridBaseWidth + horizontalPadding + scrollWidth;
  };
  $scope.toggleDeleteButton = function () {
    var length = $scope.gridOptions.rowData.length;
    $scope.showDel = $scope.gridOptions.selectedRows.length >= 1 && length !== $scope.gridOptions.selectedRows.length;
  };
  $scope.gridOptions = _.defaults({
    rowSelection: 'multiple',
    columnDefs: columnDefs,
    rowData: $scope.entity.significantPos,
    enableColResize: true,
    selectionChanged: onRowSelected,
    ready: function ready(event) {
      event.api.sizeColumnsToFit();
      $scope.resizeGrid();
    }
  }, $scope.defaultGridOptions);
};
StepSposPanelController.$inject = ['$scope'];
module.exports = StepSposPanelController;